const config = {
    APP_BASE_URL: process.env.REACT_APP_ENV === 'development' ? 'http://localhost:3001' : 'https://brasilmaisbolsas.com.br',
    API_BASE_URL: process.env.REACT_APP_ENV === 'development' ? 'http://localhost:3001/v1' : 'https://api.brasilmaisbolsas.com.br/v1',
    API_STATIC_URL: process.env.REACT_APP_ENV === 'development' ? 'http://localhost:3001' : 'https://api.brasilmaisbolsas.com.br',
};

export default config;
